var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstitution(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_946",
    "data-name": "Group 946",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.996,
    height: 26,
    viewBox: "0 0 22.996 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    "data-name": "Path 285",
    d: "M12.242,6.733H10.6V5.049a.986.986,0,1,0-1.971,0V6.733H6.986a.986.986,0,0,0,0,1.971H8.628v1.683a.986.986,0,0,0,1.971,0V8.7h1.643a.986.986,0,0,0,0-1.971",
    transform: "translate(1.884 1.276)",
    fill: "#13b4c4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_286",
    "data-name": "Path 286",
    d: "M22.011,24.029H20.368V2.31A2.31,2.31,0,0,0,18.068,0H4.92A2.311,2.311,0,0,0,2.628,2.3V24.029H.986A.986.986,0,0,0,.986,26H22.011a.986.986,0,0,0,0-1.971M9.855,17.983h3.285v6.045H9.855ZM18.4,2.321V24.029H15.112V17a.986.986,0,0,0-.986-.986H8.87A.986.986,0,0,0,7.884,17v7.032H4.6V2.31a.336.336,0,0,1,.1-.238.326.326,0,0,1,.231-.1H18.06a.331.331,0,0,1,.239.1.342.342,0,0,1,.1.246Z",
    fill: "#0e285f"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstitution);
export default __webpack_public_path__ + "static/media/institution.0bc9c8f11e8d067db626fd997be4264c.svg";
export { ForwardRef as ReactComponent };